import { Injectable } from "@angular/core";
import {
  ActivatedRouteSnapshot,
  CanActivate,
  Router,
  RouterStateSnapshot,
} from "@angular/router";

import { AutenticacaoService } from "@app/services/autenticacao.service";
import { LgpdService } from "@app/services/lgpd.service";
import { RedacaoService } from "@app/services/redacao.service";
// import { SpinnerService } from "@app/services/spinner.service";

import Swal from "sweetalert2";

@Injectable({
  providedIn: "root",
})
export class AutenticacaoGuard implements CanActivate {
  constructor(
    private router: Router,
    private autenticacaoService: AutenticacaoService,
    private redacaoService: RedacaoService,
    private lgpdService: LgpdService,
    // private spinnerService: SpinnerService
  ) { }

  async canActivate(
    activatedRouteSnapshot: ActivatedRouteSnapshot,
    routerStateSnapshot: RouterStateSnapshot
  ) {
    const query = activatedRouteSnapshot.queryParams;
    const token = query.t;
    const direto = query.direto;

    if (
      routerStateSnapshot.url.includes("/candidato/fazer-redacao") &&
      this.isValidUUID(token) &&
      direto === "1"
    ) {
      // this.spinnerService.show();
      const result = await this.redacaoService.verificarToken(token);
      // this.spinnerService.hide();

      const { idVaga, idInscricao, candidato } = result.data;

      if (!result.success) {
        const { erro, dataInicio, dataFim } = result.data;
        const _dataInicio = new Date(dataInicio);
        const _dataFim = new Date(dataFim);

        let dia: string | number = _dataInicio.getDate();
        let mes: string | number = _dataInicio.getMonth() + 1;
        let ano: string | number = _dataInicio.getFullYear();
        dia = dia < 10 ? "0" + dia : dia;
        mes = mes < 10 ? "0" + mes : mes;

        let h1: string | number = _dataInicio.getHours();
        let h2: string | number = _dataFim.getHours();
        let m1: string | number = _dataInicio.getMinutes();
        let m2: string | number = _dataFim.getMinutes();
        h1 = h1 < 10 ? "0" + h1 : h1;
        h2 = h2 < 10 ? "0" + h2 : h2;
        m1 = m1 < 10 ? "0" + m1 : m1;
        m2 = m2 < 10 ? "0" + m2 : m2;

        let msg = `A prova de redação estará disponível para acesso em ${dia}/${mes}/${ano} entre ${h1}:${m1} e ${h2}:${m2}.`;

        if (Date.now() > _dataFim.getTime()) {
          msg = `Esta prova de redação foi realizada em ${dia}/${mes}/${ano} entre ${h1}:${m1} e ${h2}:${m2}.`;
        }

        if (erro == "Token fora do período de realização da redação!") {
          Swal.fire({
            icon: "warning",
            title: "Atenção!",
            text: msg,
            allowOutsideClick: false,
            showConfirmButton: false
          });
        }

        this.router.navigate(["/login"]);
        return false;
      }

      candidato.novaSenha = false;
      this.autenticacaoService.setValorUsuarioAtualCandidato(candidato,this.autenticacaoService.getTokenCandidato());

      // try {
      //   this.spinnerService.show();
      //   const resultTermo = await this.lgpdService.verificarTermoUsuarioPromise(
      //     candidato.cpf,
      //     "PORTAL_CANDIDATO",
      //     "TERMO_DADOS_PESSOAIS"
      //   );
      //   this.spinnerService.hide();

      //   if (resultTermo) {
      this.router.navigate(["/vagas/lista"], {
        queryParams: { idVaga, idInscricao, fazerRedacao: 1 },
      });
      // } else {
      //   this.router.navigate(["/termoUsuario"], {
      //     queryParams: {
      //       urlRetorno: `/vagas/lista?idVaga=${idVaga}&idInscricao=${idInscricao}&fazerRedacao=1`,
      //       fazerRedacao: 1,
      //     },
      //   });
      // }

      return true;
      // } catch (e) {
      //   console.log(e);

      //   Swal.fire({
      //     icon: "error",
      //     title: "Erro!",
      //     text: "Aconteceu um erro inesperado ao tentar fazer a redação!"
      //   });

      //   this.spinnerService.hide();

      //   this.autenticacaoService.setValorUsuarioAtualCandidato(null);
      //   this.router.navigate(["/login"]);
      //   return false;
      // }
    }

    if (this.autenticacaoService.getValorUsuarioAtualCandidato) {
      return true;
    }

    if (routerStateSnapshot.url !== "/vagas/lista") {
      this.router.navigate(["/login"], {
        queryParams: { urlRetorno: routerStateSnapshot.url },
      });
    } else {
      this.router.navigate(["/login"]);
    }

    return false;
  }

  isValidUUID(uuid) {
    const regex =
      /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/;
    return regex.test(uuid);
  }
}
